import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Containers = () => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [baseUrl, setBaseUrl] = useState("https://devmol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("containers");
  const [data, setData] = useState(undefined);
  const [contCode, setContCode] = useState("");
  const [contDesc, setContDesc] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyContCode, setEmptyContCode] = useState(false);
  const [emptyContDesc, setEmptyContDesc] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.container_types);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setContCode("");
    setContDesc("");
  };

  const handleSave = async (event) => {
    event.preventDefault();

    if (contCode.length == 0) {
      toast.error("Container Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyContCode(true);
      setEmptyInput(true);
    } else {
      setEmptyContCode(false);
    }

    if (contDesc.length == 0) {
      toast.error("Container Name can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyContDesc(true);
      setEmptyInput(true);
    } else {
      setEmptyContDesc(false);
    }

    if (emptyInput !== true) {
      const inputData = {
        container_code: contCode,
        container_description: contDesc,
      };
      const duplicate = await data.some((el) => el.ContCode == contCode);
      if (duplicate !== true) {
        axios
          .post(`${baseUrl}${pageComponent}/store`, inputData, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          })
          .then((response) => {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("This currency code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
    }
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = {
        container_code: contCode,
        container_description: contDesc,
      };
      axios
        .post(
          `${baseUrl}${pageComponent}/update/${selectRowData.container.id}`,
          inputData,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("Please Select data Row", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  function setSelectedRow(rowid) {
    axios
      .get(`${baseUrl}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        setSelectRowData(selectRowData);
        setContCode(
          selectRowData.container.container_code
            ? selectRowData.container.container_code
            : ""
        );
        setContDesc(
          selectRowData.container.container_description
            ? selectRowData.container.container_description
            : ""
        );
        setBtnActive(false);
      });
  }

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(
      `${baseUrl}${pageComponent}/destroy/${selectRowData.container.id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    );
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };

  const tTitle = ["Container Code", "Container Description"];
  const columns = ["container_code", "container_description"];
  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>ContCode</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="CFR"
                    name="contCode"
                    value={contCode}
                    readOnly={selectRowData !== "" ? true : false}
                    className={emptyContCode == true ? "border-red2" : ""}
                    onChange={(e) => setContCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>ContDesc</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="COST AND FREIGHT"
                    name="contDesc"
                    value={contDesc}
                    className={emptyContDesc == true ? "border-red2" : ""}
                    onChange={(e) => setContDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="text-center">
              <Col className="text-end">
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={selectRowData !== "" ? edditRow : handleSave}
                  disabled={btnActive}
                >
                  Save
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={createNewRow}
                >
                  New
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={edditRow}
                  disabled={btnActive}
                >
                  Update
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={deleteRow}
                  disabled={btnActive}
                >
                  Delete
                </Button>
                <Button className="ms-3" variant="primary" disabled={btnActive}>
                  Print
                </Button>
                <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Containers;
